import { useCallback, useEffect, useState } from "react";
import { useRoomContext } from "@livekit/components-react";
import { RoomEvent } from "livekit-client";
import type { ProviderUnblockAudio } from "../types";

export const useLivekitUnblockAudio = (): ProviderUnblockAudio => {
  const room = useRoomContext();
  const [isAudioBlocked, setIsAudioBlocked] = useState(false);

  const unblockAudio = useCallback(async () => {
    await room.startAudio();
  }, [room]);

  const handleAudioPlaybackStatusChanged = useCallback((playing: boolean) => {
    setIsAudioBlocked(!playing);
  }, []);

  useEffect(() => {
    room.on(
      RoomEvent.AudioPlaybackStatusChanged,
      handleAudioPlaybackStatusChanged,
    );

    return () => {
      room.off(
        RoomEvent.AudioPlaybackStatusChanged,
        handleAudioPlaybackStatusChanged,
      );
    };
  }, [room, handleAudioPlaybackStatusChanged]);

  return {
    isAudioBlocked,
    unblockAudio,
  };
};
